<template>
  <el-dialog
    :title="$t('控制日志')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="700px"
    :custom-class="customClass"
  >
    <div class="log-dialog-body">
      <div class="log-date-row">
        <el-date-picker
          v-model="logDateRange"
          @change="onLogDateChange"
          type="daterange"
          format="yyyy-MM-dd"
          :clearable="false"
          range-separator="至"
          :start-placeholder="$t('开始日期')"
          :end-placeholder="$t('结束日期')"
        ></el-date-picker>
        <el-select
          v-model="logTypeFilter"
          @change="onLogTypeChange"
          :placeholder="$t('操作类型')"
          clearable
          class="log-type-filter"
        >
          <el-option
            v-for="item in logTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <!-- 表格容器自动占满剩余空间 -->
      <div class="log-table-wrapper">
        <el-table
          :data="logTableData"
          border
          style="width:100%; font-size:11px;"
          height="100%"
          show-overflow-tooltip
          :header-cell-style="logHeaderCellStyle"
          :cell-style="logCellStyle"
        >
          <el-table-column width="60" type="index" :label="$t('序号')" align="center"></el-table-column>
          <el-table-column
            v-for="d in logDefHead"
            :key="d.val"
            :prop="d.val"
            :label="$t(d.key)"
            sortable
          ></el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="log-pagination-row">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="pageSize"
          layout="sizes, total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <div slot="footer" class="dialog-custom-footer">
      <button class="close-btn" @click="dialogVisible = false">{{ $t('关闭') }}</button>
    </div>
  </el-dialog>
</template>
<script>
import moment from 'moment/moment';

export default {
  name:'DiaLogDev',
  props:{
    visible:{
      type:Boolean,
      default:false
    },
    siteData:{
      type:Object,
      default:() => ({})
    },
    /* 主题标识：'1' 为浅色主题，其它为深色主题 */
    bj:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      page:1,
      pageSize:30,
      total:0,
      logDateRange:[],
      logTableData:[],
      logDefHead:[
        {key:'操作时间',val:'uptime'},
        {key:'操作来源',val:'ctr_type'},
        {key:'操作类型',val:'set_type'},
        {key:'操作内容',val:'set_val'},
        {key:'操作结果',val:'res'}
      ],
      logTypeFilter:'',
      logTypeOptions:[
        {label:this.$t('开关'),value:'开关'},
        {label:this.$t('模式'),value:'模式'},
        {label:this.$t('锁定'),value:'锁定'},
        {label:this.$t('状态'),value:'状态'}
      ],
      logLoading:null
    };
  },
  computed:{
    dialogVisible:{
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible',val);
      }
    },
    customClass() {
      return this.bj === '1' ? 'kt-log-dialog theme-light':'kt-log-dialog';
    }
  },
  watch:{
    visible(val) {
      if (val) {
        this.page = 1;
        this.pageSize = 30;
        this.total = 0;
        this.logTypeFilter = '';
        this.logDateRange = this.getYesterday();
        this.$nextTick(() => {
          this.getLogData();
        });
      } else {
        this.logTableData = [];
      }
    }
  },
  methods:{
    onLogDateChange() {
      if (!this.logDateRange || this.logDateRange.length !== 2) return;
      this.page = 1;
      this.logLoading = this.$loading({spinner:'',text:this.$t('正在加载中...'),background:'rgba(0, 0, 0, 0.3)'});
      this.getLogData();
    },
    onLogTypeChange() {
      this.page = 1;
      this.logLoading = this.$loading({spinner:'',text:this.$t('正在加载中...'),background:'rgba(0, 0, 0, 0.3)'});
      this.getLogData();
    },
    getLogData() {
      const wgMac = this.siteData.wg_mac || this.siteData.mac || '';
      const wgQid = this.siteData.wg_qid || '';
      if (!wgMac || !wgQid) {
        if (this.logLoading) this.logLoading.close();
        return;
      }
      const params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'start_time':this.formatDateTime(this.logDateRange[0],'day'),
        'end_time':this.formatDateTime(this.logDateRange[1],'day'),
        'wg_mac':wgMac,
        'wg_qid':wgQid,
        'page':this.page,
        'pageSize':this.pageSize
      };
      if (this.logTypeFilter) {
        params.set_type = this.logTypeFilter;
      }
      this.$api.get(this.$urls.ip + this.$urls.get_log_one_dev,params).then(res => {
        if (this.logLoading) this.logLoading.close();
        let lsData = [];
        let total = 0;
        const resData = res.data && res.data.data ? res.data.data:(res.data || []);
        if (Array.isArray(resData)) {
          lsData = resData;
          total = (res.data && res.data.total) ? res.data.total:resData.length;
        } else {
          lsData = resData.list || resData.data || [];
          total = resData.total || lsData.length;
        }
        const lData = [];
        for (let i = 0; i < lsData.length; i++) {
          const d = {
            uptime:lsData[i]['uptime'],
            ctr_type:this.$t(lsData[i]['ctr_type']),
            set_type:this.$t(lsData[i]['set_type']),
            set_val:this.$t(lsData[i]['set_val']),
            res:lsData[i]['res']
          };
          if (d.res === '1') {
            d.res = this.$t('控制成功');
          } else {
            d.res = this.$t('控制失败');
          }
          lData.push(d);
        }
        this.total = total;
        this.logTableData = lData.sort((a,b) => {
          return new Date(b.uptime) - new Date(a.uptime);
        });
      }).catch(error => {
        if (this.logLoading) this.logLoading.close();
        this.$message.error(this.$t('获取控制日志失败，请稍后重试'));
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.logLoading = this.$loading({spinner:'',text:this.$t('正在加载中...'),background:'rgba(0, 0, 0, 0.3)'});
      this.getLogData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.logLoading = this.$loading({spinner:'',text:this.$t('正在加载中...'),background:'rgba(0, 0, 0, 0.3)'});
      this.getLogData();
    },
    getYesterday() {
      return [
        new Date(moment().subtract(1,'day').format('YYYY-MM-DD')),
        new Date(moment().subtract(0,'day').format('YYYY-MM-DD'))
      ];
    },
    pad(num) {
      return num.toString().padStart(2,'0');
    },
    formatDateTime(date,name) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      switch (name) {
        case 'day':
          return `${year}-${this.pad(month)}-${this.pad(day)}`;
        default:
          return `${year}-${this.pad(month)}-${this.pad(day)}`;
      }
    },
    logHeaderCellStyle() {
      if (this.bj === '1') {
        return {textAlign:'center',background:'#FFFFFF',color:'#000000'};
      }
      return {textAlign:'center',background:'#283A4D',color:'#ffffff'};
    },
    logCellStyle() {
      if (this.bj === '1') {
        return {textAlign:'center',background:'#FFFFFF',color:'#000000'};
      }
      return {textAlign:'center',background:'#283A4D',color:'#ffffff'};
    }
  }
};
</script>
<style>
/* ===== 控制日志弹窗全局样式覆盖 ===== */
.kt-log-dialog .el-dialog {
  margin-top: 6vh !important;
  background: #283A4D !important;
  border-radius: 16px;
  border: 1px solid #3A506B;
  height: 65vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.kt-log-dialog .el-dialog__header {
  padding: 18px 20px 12px 20px;
  background: #283A4D;
  flex-shrink: 0; /* 标题栏高度固定，不压缩 */
}

.kt-log-dialog .el-dialog__title {
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
}

.kt-log-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #8DA5BE;
}

.kt-log-dialog .el-dialog__headerbtn:hover .el-dialog__close {
  color: #0DA7C8;
}

/* 核心修改：弹窗主体区域 flex 占满剩余高度 */
.kt-log-dialog .el-dialog__body {
  padding: 0 20px 15px 20px;
  background: #283A4D;
  color: #ffffff;
  flex: 1; /* 自动填充弹窗剩余高度 */
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.kt-log-dialog .el-dialog__footer {
  padding: 0 20px 20px 20px;
  border-top: none;
  background: #283A4D;
  flex-shrink: 0; /* 底部按钮栏高度固定，不压缩 */
}

.kt-log-dialog.theme-light .el-dialog,
.kt-log-dialog.theme-light .el-dialog__header,
.kt-log-dialog.theme-light .el-dialog__body,
.kt-log-dialog.theme-light .el-dialog__footer {
  background: #FFFFFF;
  color: #000000;
}

.kt-log-dialog.theme-light .el-dialog {
  border: 1px solid #C8CDD4;
}

.kt-log-dialog.theme-light .el-dialog__title {
  color: #000000;
}

.kt-log-dialog.theme-light .el-dialog__headerbtn .el-dialog__close {
  color: #6B767E;
}

.kt-log-dialog.theme-light .el-dialog__headerbtn:hover .el-dialog__close {
  color: #0DA7C8;
}

.kt-log-dialog .el-table,
.kt-log-dialog .el-table__expanded-cell,
.kt-log-dialog .el-table th,
.kt-log-dialog .el-table tr,
.kt-log-dialog .el-table td {
  background: transparent;
}

.kt-log-dialog.theme-light .el-table,
.kt-log-dialog.theme-light .el-table__expanded-cell,
.kt-log-dialog.theme-light .el-table th,
.kt-log-dialog.theme-light .el-table tr,
.kt-log-dialog.theme-light .el-table td {
  background: #FFFFFF;
}

.kt-log-dialog.theme-light .el-table--border,
.kt-log-dialog.theme-light .el-table--group,
.kt-log-dialog.theme-light .el-table td,
.kt-log-dialog.theme-light .el-table th.is-leaf {
  border-color: #C8CDD4;
}

.kt-log-dialog .el-table--border,
.kt-log-dialog .el-table--group,
.kt-log-dialog .el-table td,
.kt-log-dialog .el-table th.is-leaf {
  border-color: #3A506B;
}

.kt-log-dialog .el-table::before {
  background-color: #3A506B;
}

.kt-log-dialog.theme-light .el-table::before {
  background-color: #C8CDD4;
}

.kt-log-dialog .el-input__inner,
.kt-log-dialog .el-range-editor {
  background: #1A2838;
  border-color: #2E4056;
  color: #C0D8E8;
}

.kt-log-dialog.theme-light .el-input__inner,
.kt-log-dialog.theme-light .el-range-editor {
  background: #FFFFFF;
  border-color: #C8CDD4;
  color: #283A4D;
}

.kt-log-dialog .el-range-editor .el-range-input {
  background: transparent;
  color: #C0D8E8;
}

.kt-log-dialog.theme-light .el-range-editor .el-range-input {
  color: #283A4D;
}

.kt-log-dialog .el-range-editor .el-range-separator {
  color: #8DA5BE;
}

.kt-log-dialog.theme-light .el-range-editor .el-range-separator {
  color: #6B767E;
}

/* 分页器深色主题适配 */
.kt-log-dialog .el-pagination__total,
.kt-log-dialog .el-pagination__jump,
.kt-log-dialog .el-pager li,
.kt-log-dialog .el-pagination button,
.kt-log-dialog .el-pagination__editor {
  color: #C0D8E8;
}

.kt-log-dialog .el-pager li.btn-quicknext,
.kt-log-dialog .el-pager li.btn-quickprev {
  color: #C0D8E8;
}

.kt-log-dialog .el-pager li:hover,
.kt-log-dialog .el-pager li.active,
.kt-log-dialog .el-pagination button:hover {
  color: #0DA7C8;
}

.kt-log-dialog .el-pagination .el-input__inner {
  background: #1A2838;
  border-color: #2E4056;
  color: #C0D8E8;
}

.kt-log-dialog.theme-light .el-pagination__total,
.kt-log-dialog.theme-light .el-pagination__jump,
.kt-log-dialog.theme-light .el-pager li,
.kt-log-dialog.theme-light .el-pagination button,
.kt-log-dialog.theme-light .el-pagination__editor,
.kt-log-dialog.theme-light .el-pager li.btn-quicknext,
.kt-log-dialog.theme-light .el-pager li.btn-quickprev {
  color: #283A4D;
}

.kt-log-dialog.theme-light .el-pager li:hover,
.kt-log-dialog.theme-light .el-pager li.active,
.kt-log-dialog.theme-light .el-pagination button:hover {
  color: #0DA7C8;
}

.kt-log-dialog.theme-light .el-pagination .el-input__inner {
  background: #FFFFFF;
  border-color: #C8CDD4;
  color: #283A4D;
}
</style>
<style scoped>
.dialog-custom-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 5px;
}

.close-btn {
  padding: 8px 28px;
  border-radius: 8px;
  border: 1px solid #0dA7C8;
  background: transparent;
  color: #0dA7C8;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.close-btn:hover {
  background: #0dA7C8;
  color: #ffffff;
}

.log-dialog-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%; /* 继承父级 el-dialog__body 高度 */
  min-height: 0;
}

.log-date-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0; /* 日期栏高度固定，不压缩 */
}

.log-type-filter {
  width: 120px;
}

.log-table-wrapper {
  height: calc(55vh - 42px);
  min-height: 0; /* 修复 flex 内容溢出问题 */
  overflow: hidden;
}

.log-pagination-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  padding-top: 6px;
}

.log-pagination-row .el-pagination__sizes .el-input .el-input__inner {
  width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/dialog/diaLogDev.vue